export default "__VITE_ASSET__f02acd4c__"